import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { Authentication } from '@leedpulse-monorepo/classes';

export interface SendSMSTestResponse {
  success: boolean;
  statusCode: number;
  statusResponse: string;
  data: any;
}

export interface SMSTestPayload {
  receiver: string;
  sender: string;
  message: string;
  provider: string;
  groupId: string;
  groupName: string;
}

async function sendSMSTest(
  payload: SMSTestPayload,
  auth: Authentication): Promise<SendSMSTestResponse> {
  try {
    const response = await HttpClient.post(
      '/sms/send/test',
      payload,
      auth.token,
      false,
      {
        'x-receiver': payload.receiver,
        'x-sender': payload.sender,
        'Content-Type': 'application/json'
      }
    );

    if (response.success) {
      return response;
    } else {
      console.log('error: ', response);
      throw new SendSMSTestFailure();
    }
  } catch (e) {
    console.log('error: ', e);
    throw new SendSMSTestFailure();
  }
}

export class SendSMSTestFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default sendSMSTest;
